module.exports = __webpack_public_path__ + "img/icon-danger.3ac801fa.svg";